import { Button, Typography, Upload } from "antd";
import type { RcFile } from "antd/es/upload";
import clsx from "clsx";
import "./document-selector.scss";
import { formatSize } from "@/shared/utils";
import { DocumentSelectorWrapper } from "@features/document-selector-wrapper";
import { DelIcon } from "@shared/assets/svg/icons";

const { Link, Text } = Typography;

interface IDocumentSelector {
  label: string;
  accept: Array<string>;
  className?: string;
  onFileSelect: (file: RcFile) => void;
  onFileRemove: () => void;
  defaultFileName?: string;
  defaultFileLink?: string;
  defaultFileSize?: number;
  fileName?: string;
  extensions?: string[];
}

export const DocumentSelector = ({
  label,
  accept,
  className,
  onFileSelect,
  onFileRemove,
  defaultFileName,
  defaultFileLink,
  defaultFileSize,
  fileName,
  extensions,
}: IDocumentSelector) => {
  return (
    <DocumentSelectorWrapper
      onFileRemove={onFileRemove}
      onFileSelect={onFileSelect}
      defaultFileName={defaultFileName}
      defaultFileLink={defaultFileLink}
      defaultFileSize={defaultFileSize}
    >
      {({
        selected,
        handleFileSelect,
        handleFileRemove,
        selectedFileLink,
        selectedFileSize,
        selectedFileName,
      }) => (
        <div className={clsx("file-selector-internals", className)}>
          {selected ? (
            <>
              <span className="file-selector-internals-filedata">
                <Link
                  target="_blank"
                  href={selectedFileLink!}
                  className="file-selector-internals-filename"
                  rel="nofollow"
                >
                  {fileName ?? selectedFileName}
                </Link>
                <Text className="file-selector-internals-metadata">
                  {formatSize(selectedFileSize!)}
                </Text>
              </span>
              <Button
                aria-label="Удалить организацию"
                className="file-selector-internals-remove"
                icon={<DelIcon />}
                onClick={handleFileRemove}
              />
            </>
          ) : (
            <>
              <span className="file-selector-internals-filedata">
                <Text ellipsis className="document-selector-button-title">
                  {label}
                </Text>
                <Text className="file-selector-internals-metadata">
                  {extensions?.map((e) => `.${e}`).join(" ")}
                </Text>
              </span>
              <Upload
                multiple={false}
                maxCount={1}
                name="permission"
                showUploadList={false}
                accept={accept?.filter(Boolean).join(",")}
                beforeUpload={() => false}
                onChange={handleFileSelect}
              >
                <Button className="file-selector-internals-add">
                  Загрузить
                </Button>
              </Upload>
            </>
          )}
        </div>
      )}
    </DocumentSelectorWrapper>
  );
};
